<template>
  <div id="commission-tiers-commissions">
    <SimplePageHeader title="Commission Tiers"></SimplePageHeader>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          class="mb-3"
          dense
          :headers="headers"
          :items="commissionTiers"
          item-key="minAmount"
          :items-per-page="-1"
          hide-default-footer
        >
          <template v-slot:item.minAmount="{ item }">
            {{ item.minAmount | currency}}
          </template>
          <template v-slot:item.maxAmount="{ item }">
            {{ item.maxAmount | currency}}
          </template>
          <template v-slot:item.commissionPercent="{ item }">
            {{ item.commissionPercent | percent}}
          </template>
          <template v-slot:item.commissionAmount="{ item }">
            {{ item.commissionAmount | currency}}
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'

export default {
  components: {
    SimplePageHeader
  },
  props: [
    'commissionTiers'
  ],
  data () {
    return {
      headers: [
        { text: 'From', value: 'minAmount', align: 'center', sortable: false },
        { text: 'To', value: 'maxAmount', align: 'center', sortable: false },
        { text: 'Commission %', value: 'commissionPercent', align: 'center', sortable: false },
        { text: 'Commission Amount', value: 'commissionAmount', align: 'center', sortable: false }
      ]
    }
  }
}
</script>

<style>

</style>
